<template>
  <section id="contact" class="section-padding">
    <div class="container">
      <div class="contact-module-container">
        <div class="text-center mb-4">
          <h2 class="section-title">联系协会</h2>
          <div class="section-divider w-20 mx-auto"></div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div v-if="contactArticle" class="h-full min-h-[300px] rounded-lg shadow-lg overflow-hidden">
          <img :src="contactArticle.coverImageUrl || 'https://picsum.photos/seed/map/600/400.jpg'" alt="地图" class="w-full min-h-full object-cover" loading="lazy">
        </div>

        <div v-if="contactArticle" class="h-full">
          <div class="card-base p-8 h-full flex flex-col">
            <h3 class="text-xl font-bold mb-4 text-gray-800">协会秘书处</h3>
            <div class="text-gray-600 flex-1" v-html="contactArticle.contentHtml"></div>
          </div>
        </div>

        <!-- 加载状态 -->
        <div v-else class="col-span-full text-center py-10 text-gray-500">加载中...</div>
      </div>
      </div>
    </div>
  </section>
</template>

<script>
import { api } from '../api'

export default {
  name: 'ContactSection',
  data() {
    return {
      contactArticle: null,
      loading: false
    }
  },
  async mounted() {
    await this.loadContactData()
  },
  methods: {
    async loadContactData() {
      try {
        this.loading = true
        const article = await api.getArticleDetail(20)
        this.contactArticle = article
      } catch (error) {
        console.error('加载联系协会数据失败:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
/* 背景色设置 */
.section-padding {
  background-color: var(--bg);
  position: relative;
  overflow: hidden;
  padding: 16px 0;
}

/* 联系协会模块容器 */
.contact-module-container {
  background: #ffffff;
  border-radius: 32px;
  box-shadow: none;
  padding: 48px 40px;
  margin-bottom: 0;
  border: none;
  position: relative;
  z-index: 1;
}

.section-padding::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 30% 70%, rgba(96, 165, 250, 0.1) 0%, transparent 60%);
  pointer-events: none;
  z-index: 0;
}

/* 内容容器 */
.container {
  position: relative;
  z-index: 1;
}

/* 标题容器样式 */
.contact-module-container .text-center {
  background: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border-radius: 0;
  box-shadow: none;
  border: none;
  padding: 0;
}

/* 蓝色分隔线样式 */
.section-divider {
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--accent), transparent);
  margin: 1rem auto;
  box-shadow: none;
}

/* 地图容器 */
#contact img {
  border-radius: var(--radius-2xl);
  box-shadow: none;
  border: none;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
  height: auto;
  background: var(--surface);
  backdrop-filter: blur(20px) saturate(120%);
  -webkit-backdrop-filter: blur(20px) saturate(120%);
}

#contact img:hover {
  /*transform: scale(1.02);*/
  box-shadow: none;
  border: none;
}

/* 联系信息卡片 */
.contact-module-container .card-base {
  background: var(--surface);
  backdrop-filter: blur(20px) saturate(120%);
  -webkit-backdrop-filter: blur(20px) saturate(120%);
  border-radius: var(--radius-2xl);
  box-shadow: none;
  border: none !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.contact-module-container .card-base:hover {
  /*transform: translateY(-8px) scale(1.015);*/
  box-shadow: none;
  border: none !important;
}

/* 联系信息标题 */
.card-base h3 {
  color: var(--text-primary);
  font-weight: 600;
  margin-bottom: 24px;
  transition: color 0.3s ease;
}

.card-base:hover h3 {
  color: var(--accent);
  text-shadow: 0 0 10px rgba(96, 165, 250, 0.5);
}

/* 联系信息内容 */
.card-base .text-gray-600 {
  color: var(--text-secondary);
  line-height: 1.6;
}

/* 联系信息中的图标 */
.card-base i.fa {
  color: var(--accent);
  margin-right: 12px;
  transition: transform 0.3s ease;
}

.card-base:hover i.fa {
  /*transform: scale(1.1);*/
  color: var(--accent-light);
}

/* 加载状态 */
#contact .text-center {
  background: var(--surface);
  backdrop-filter: blur(20px) saturate(120%);
  -webkit-backdrop-filter: blur(20px) saturate(120%);
  border-radius: var(--radius-lg);
  box-shadow: none;
  border: none;
  padding: 60px 20px;
}

#contact .text-center div {
  color: var(--text-secondary);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .section-padding {
    padding: 48px 0;
  }

  .card-base.p-8 {
    padding: 24px;
  }

  .card-base h3 {
    font-size: 1.25rem;
  }
}

@media (max-width: 480px) {
  .card-base.p-8 {
    padding: 16px;
  }

  .space-y-3 > div {
    flex-direction: column;
    align-items: flex-start;
  }

  .card-base i.fa {
    margin-bottom: 8px;
  }
}
</style>
